// extracted by mini-css-extract-plugin
export default {"content":"Duvidas_content__zyKOr"};